import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'room service',
      [RoomServiceLocationType.TableService]: 'service à table',
    },
    [ORDER_METHODS.PICKUP]: 'à emporter',
    [ORDER_METHODS.DELIVERY]: 'livraison',
  },
  errors: {
    draft_validation_failed: 'Veuillez compléter votre adresse de livraison avant de continuer.',
  },
};
